import React from "react"

function NotFound({ err }) {
  return (
    <div className="err">
      <h2> You have encountered an unforeseen error. </h2>
      <h3> {err} </h3>
    </div>
  )
}

export default NotFound
